<template>
    <el-dialog
		custom-class="agreement-dialog"
      title="隐私协议"
      :visible.sync="dialogVisible"
	  append-to-body
      width="600px"
	  top="100px"
      center>
      <div class="textbox">
		  生效日期：2025年10月28日
		  
		  欢迎使用【你的产品/服务名称】（以下简称“本服务”）。我们深知个人信息对您的重要性，并承诺依法保护您的个人信息安全。本《隐私协议》（以下简称“本协议”）将详细说明我们如何收集、使用、存储、共享、转让、公开披露您的个人信息，以及您享有的权利。
		  
		  请您在使用本服务前，仔细阅读并充分理解本协议内容。如您不同意本协议任何内容，请立即停止使用本服务。您的使用行为将被视为对本协议全部内容的认可。
		  
		  一、我们如何收集和使用您的个人信息
		  1.1 为实现核心功能所必需的信息
		  账号注册/登录：当您注册账号或使用第三方登录（如微信、手机号）时，我们会收集您的手机号、微信昵称、头像等，用于创建账户并提供基础服务。
		  提供服务：为向您提供具体功能（如订单处理、内容发布、消息通知等），我们可能收集您的设备信息（如 IP 地址、设备型号、操作系统）、操作日志、位置信息（如需定位服务）等。
		  1.2 为提升体验而收集的信息（经您同意）
		  个性化推荐：基于您的浏览、搜索、使用习惯，我们可能使用您的行为数据优化推荐内容。
		  客服与反馈：当您联系客服时，我们会记录沟通内容以解决问题。
		  1.3 征得同意的例外情形
		  根据法律法规，以下情形我们可能无需征得您的授权同意：
		  
		  为履行法定义务所必需；
		  为应对突发公共卫生事件，或紧急情况下为保护您或他人的生命财产安全；
		  为公共利益实施新闻报道、舆论监督；
		  在合理范围内处理您自行公开或其他已合法公开的个人信息。
		  二、我们如何使用 Cookie 和同类技术
		  我们可能使用 Cookie、本地存储等技术：
		  
		  记住您的登录状态；
		  分析网站流量和用户行为；
		  提供个性化广告（如适用）。
		  您可通过浏览器设置拒绝 Cookie，但可能影响部分功能正常使用。
		  
		  三、我们如何共享、转让、公开披露您的个人信息
		  3.1 共享
		  我们不会向任何无关第三方共享您的个人信息，除非满足以下条件之一：
		  
		  获得您的明确同意；
		  与关联公司共享（仅限必要范围，并要求其遵守本协议）；
		  委托第三方服务商（如云服务、支付、数据分析）处理信息，我们会与其签署保密协议；
		  根据法律法规或政府机关要求。
		  3.2 转让与公开披露
		  原则上我们不会转让或公开披露您的个人信息。如因合并、收购、破产清算等原因确需转让，我们将要求新控制方继续履行本协议义务。
		  
		  四、我们如何存储和保护您的个人信息
		  存储地点：您的个人信息将存储于中华人民共和国境内。如需跨境传输，我们将依法取得您的单独同意并采取必要保护措施。
		  存储期限：在实现本服务目的所必需的最短期限内保留，法律法规另有规定的除外。
		  安全措施：我们采用加密、访问控制、安全审计等技术和管理措施，防止信息泄露、篡改、丢失。
		  五、您的权利
		  您有权：
		  
		  查询、更正、删除您的个人信息；
		  撤回已同意的授权（通过设置或联系客服）；
		  注销账户（路径：【我的】-【设置】-【注销账号】）；
		  获取个人信息副本；
		  对自动化决策（如推荐算法）提出异议；
		  向监管部门投诉（如拨打 12377 网络举报热线）。
		  我们将在 15 个工作日内响应您的请求。
		  
		  六、未成年人保护
		  本服务不面向未满 14 周岁的未成年人。如发现误收集其信息，我们将立即删除。
		  
		  七、本协议的更新
		  我们可能适时修订本协议。更新后将通过公告、推送或弹窗等方式通知您。若您继续使用服务，视为接受修改。
		  
		  八、联系我们
		  如您对本协议或个人信息处理有任何疑问，请通过以下方式联系我们：
		  
		  邮箱：【privacy@yourdomain.com】
		  地址：【公司注册地址】
		  客服电话：【400-xxx-xxxx】
		  我们设有个人信息保护负责人，您也可通过上述方式与其联系。
	  </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="green" @click="agree()">同意并继续</el-button>
      </span>
    </el-dialog>
</template>

<script>
import ty from "@/utils/ty/ty"
import util from "@/common/util.js"
export default {
    name: 'agreement',
    props: {
        // 外部参数示例
        // data: {
        //     type: Array,
        //     default: () => []
        // },
    },
    data() {
        return {
            // 内部参数
			dialogVisible:false,
        }
    },
    methods: {
		agree(){
			this.dialogVisible = false
			this.$emit("agree")
		},
    },
    mounted() {

    }

}
</script>

<style lang="scss">
	@import "agreement.scss";
</style>